module.exports = __webpack_public_path__ + "media/games-20.edb8313c.mp4";